import React, { useState } from "react";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import image from "../../images/contact-min.png";
import styles from "../Navigation/myButton.module.css";

const MakeAppoinment = () => {
  const [data, setData] = useState({});

  const handleField = (e) => {
    const field = e.target.name;
    const value = e.target.value;
    const newField = { ...data };
    newField[field] = value;
    setData(newField);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Check if any required fields are empty
    if (!data.name || !data.email || !data.address || !data.subject) {
      alert("Please fill out all required fields");
      return;
    }

    const appoinment = {
      service: data.subject,
      username: data.name,
      useraddress: data.address,
      userphone: data.phone,
      comments: data.comments,
      date: new Date().toLocaleDateString(),
    };

    fetch("https://cleaner-server.onrender.com/appoinment/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(appoinment),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          alert("Your appointment has been accepted");
          // Reset the form state
          setData({
            name: "",
            email: "",
            address: "",
            subject: "",
            comments: "",
          });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Failed to submit appointment. Please try again later.");
      });
  };

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-lg-6 col-12 col-md-12 sm-order-1">
          <Form className={styles.form} onSubmit={handleSubmit}>
            <div className="d-flex justify-content-start mb-3">
              <div className={styles.fancyDot}></div>
              <div className={styles.fancyDot2}></div>
            </div>
            <h1 className="text-white mb-3">
              Make An <br /> Appointment
            </h1>
            <Row className="mb-0">
              <Form.Group as={Col} controlId="formGridName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter name"
                  name="name"
                  value={data.name}
                  onChange={handleField}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  name="email"
                  value={data.email}
                  onChange={handleField}
                />
              </Form.Group>
            </Row>

            <Row className="mb-4">
              <Form.Group as={Col} controlId="formGridAddress">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  placeholder="1234 Main St"
                  name="address"
                  value={data.address}
                  onChange={handleField}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="formGridSubject">
                <Form.Label>Subject</Form.Label>
                <Form.Select
                  name="subject"
                  value={data.subject}
                  onChange={handleField}
                >
                  <option>Choose...</option>
                  <option value="office">Office</option>
                  <option value="home">Home</option>
                  <option value="shop">Shop</option>
                  <option value="road">Road</option>
                </Form.Select>
              </Form.Group>
            </Row>

            <FloatingLabel
              className="my-4"
              controlId="floatingTextarea2"
              label="Comments"
            >
              <Form.Control
                as="textarea"
                placeholder="Leave a comment here"
                style={{ height: "100px" }}
                name="comments"
                value={data.comments}
                onChange={handleField}
              />
            </FloatingLabel>
            <Button
              type="submit"
              className={styles.myButton2}
              variant="warning"
            >
              Submit Request
            </Button>
          </Form>
        </div>
        <div className="col-lg-6 col-12 col-md-12">
          <img className="w-100" src={image} alt="" />
        </div>
      </div>
    </div>
  );
};

export default MakeAppoinment;
